<template>
  
    <g-popup :title="$t('pages_user_CustomerInfo.has-force-logouted-title')" :show="true" :instKey="instKey" :background-click="false" @before-close="onBeforeClose">
      <template #body>
        
        <div class="-font-size-12">
            <h3 class="-mb-5 -h3 -font-weight-regular" v-text="$t('pages_user_CustomerInfo.has-force-logouted-message-one')"></h3>
            <h3 class="-h3 -font-weight-regular" v-text="$t('pages_user_CustomerInfo.has-force-logouted-message-two')"></h3>
        </div>

      </template>
      <template #footer>
        <g-button
          id="customer-info-save"
          variant="primary"
            class="-mr-0"
            :text="$t('common.ok')"
            @click="onClickConfirm">
          <span>{{$t('common.ok')}}</span>
        </g-button>
      </template>
    </g-popup>
</template>

<script>

export default {
  props: {
    instKey: {
      type: String,
      default: null
    }
  },
  computed: {
  },
  methods: {
    onClickConfirm () {
      window.keycloak.logout();
    },
    onBeforeClose(){
      window.keycloak.logout();
    }
  },
  mounted () {
    //window.keycloak['onAuthLogout']();
  }
}


</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/user/components/UserLogoutForce.vue